import { render } from "./DefaultOrCustomValueNumberInput.vue?vue&type=template&id=82f5806a&scoped=true&lang=pug"
import script from "./DefaultOrCustomValueNumberInput.vue?vue&type=script&lang=ts"
export * from "./DefaultOrCustomValueNumberInput.vue?vue&type=script&lang=ts"

import "./DefaultOrCustomValueNumberInput.vue?vue&type=style&index=0&id=82f5806a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-82f5806a"

export default script